// The static page (public/index.html) in the current language: <html lang>, elements marked data-i18n-html
// (dictionary markup — ours, never player text), data-i18n-aria and data-i18n-title, and the words CSS draws
// itself (`content: var(--t-…)` on plates and passive slots).
import { getLang, t, type MsgKey } from './index.js';

const CSS_WORDS: [string, MsgKey][] = [
  ['--t-charm', 'plate.charm'], ['--t-fear', 'plate.fear'], ['--t-stun', 'plate.stun'], ['--t-brace', 'plate.brace'],
  ['--t-passive', 'slot.passive'],
];

export function applyStaticI18n(doc: Document) {
  doc.documentElement.lang = getLang();
  applyI18nAttrs(doc);
  for (const [name, key] of CSS_WORDS) doc.documentElement.style.setProperty(name, JSON.stringify(t(key)));
}

/** Fills every element under `root` marked data-i18n-html (its markup), data-i18n-aria (aria-label) or
    data-i18n-title (title) from the dictionary — for static templates that outlive a language switch. */
export function applyI18nAttrs(root: ParentNode) {
  root.querySelectorAll<HTMLElement>('[data-i18n-html]').forEach(el => { el.innerHTML = t(el.dataset.i18nHtml as MsgKey); });
  root.querySelectorAll<HTMLElement>('[data-i18n-aria]').forEach(el => el.setAttribute('aria-label', t(el.dataset.i18nAria as MsgKey)));
  root.querySelectorAll<HTMLElement>('[data-i18n-title]').forEach(el => { el.title = t(el.dataset.i18nTitle as MsgKey); });
}
